export const log = (...txt: any) => {
  console.log(...txt);
};